import { InspectionCharger } from "./InspectionCharger";
import { BusinessTypeEnum } from "@/enum/BusinessTypeEnum";

export type StationCharger = Pick<
    InspectionCharger,
    | "chargerId"
    | "maker"
    | "connectorType"
    | "chargerCapacity"
    | "chargerType"
    | "serialNumber"
    | "modemNumber"
    | "firmwareVersion"
    | "wireWidth"
    | "modelName"
    | "modelNameCardNumber"
    | "installType"
    | "lcdType"
    | "androidType"
    | "chargerOutlet"
>;

export class StationDetail {
    /**
     * 충전소 아이디
     */
    readonly stationId: string;
    /**
     * 충전소 명
     */
    readonly stationName: string;
    /**
     * 주소
     */
    readonly stationAddress: string;
    /**
     * 충전기 사업자
     */
    readonly owner: string;
    /**
     * 환경부 충전소 ID
     */
    readonly kecoStationId: string;
    /**
     * X 좌표
     */
    readonly gpsX: number;
    /**
     * Y 좌표
     */
    readonly gpsY: number;
    /**
     * 충전기 개수
     */
    readonly chargerCount: number;
    /**
     * 충전소 리스트
     */
    readonly chargerList: StationCharger[];
    /**
     * 충전기 제조사
     * */
    readonly makers: string[];
    /**
     * 사업명 (점검 유형)
     */
    readonly businessName: BusinessTypeEnum | null;
}